import { render, staticRenderFns } from "./password-reset-request.vue?vue&type=template&id=5f87e981"
import script from "./password-reset-request.vue?vue&type=script&setup=true&lang=ts"
export * from "./password-reset-request.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports